import React, { useState } from 'react';
import styles from './TopBar.module.scss';
import { SFIconButton } from 'sfui';
import { BrandButton } from '../BrandButton/BrandButton';
import { LinksPanel } from './LinksPanel/LinksPanel';
import { HeaderLink, Topic } from '../../Models';
import { useDesktopQuery } from '../../Hooks';
import { LinksBar } from './LinksBar/LinksBar';
import { SearchCollapse } from './SearchCollapse/SearchCollapse';
import { SearchSlide } from './SearchSlide/SearchSlide';

export interface TopBarProps {
  icon: string;
  links: HeaderLink[];
  topics: Topic[];
}

export const TopBar = ({
  icon,
  links,
  topics
}: TopBarProps): React.ReactElement<TopBarProps> => {
  const isDesktop = useDesktopQuery();
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false);
  const [isSearchVisible, setIsSearchVisible] = useState<boolean>(false);

  const onHideSearch = () => setIsSearchVisible(false);

  return (
    <div className={styles.topBar}>
      <LinksPanel
        isOpen={isPanelOpen}
        links={links}
        onClose={() => setIsPanelOpen(false)}
      />

      <div className={styles.mainBar}>
        <BrandButton icon={icon} />

        <div className={styles.rightMenu}>
          <div>
            {isDesktop && <LinksBar links={links} />}

            {(isDesktop || !isSearchVisible) && (
              <SFIconButton
                sfIcon="Search"
                sfSize="medium"
                onClick={() => setIsSearchVisible(true)}
                aria-label="Search"
              />
            )}

            {isDesktop && isSearchVisible && (
              <SearchSlide
                show={isSearchVisible}
                topics={topics}
                onHide={onHideSearch}
              />
            )}
          </div>

          {!isDesktop && (
            <SFIconButton
              sfIcon="Menu-1"
              iconSize="large"
              buttonSize="medium"
              onClick={() => setIsPanelOpen(true)}
              aria-label="Menu"
            />
          )}
        </div>
      </div>

      {!isDesktop && (
        <SearchCollapse
          show={isSearchVisible}
          topics={topics}
          onHide={onHideSearch}
        />
      )}
    </div>
  );
};
